<script setup lang="ts">
import { onMounted, watch } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";

import { pingAppActivity, setTokenProvider, setUnauthorizedHandler } from "@/api/client";

const auth = useAuth0();

function signOut(): void {
  void auth.logout({ logoutParams: { returnTo: window.location.origin } });
}

onMounted(() => {
  setTokenProvider(async () => {
    if (!auth.isAuthenticated.value) return undefined;
    try {
      return await auth.getAccessTokenSilently();
    } catch {
      // The session/refresh token is dead — sign out rather than send a
      // request with no token and get stuck on 401s.
      signOut();
      return undefined;
    }
  });

  // A 401 from the API means the session expired — log out cleanly.
  setUnauthorizedHandler(signOut);

  // Record app usage if already signed in on load (best-effort telemetry).
  if (auth.isAuthenticated.value) void pingAppActivity("web");
});

watch(
  () => auth.isAuthenticated.value,
  (signedIn) => {
    if (signedIn) void pingAppActivity("web");
    else setTokenProvider(async () => undefined);
  },
);
</script>

<template>
  <RouterView />
</template>
